function questionPrefix(flowKey, streetKey, scenarioValue) {
  const base = `flows.${flowKey}.streets.${streetKey}`;
  return scenarioValue ? `${base}.scenarios.${scenarioValue}` : base;
}

export function closedQuestionForStreet(flowKey, streetKey, scenarioValue) {
  const p = `${questionPrefix(flowKey, streetKey, scenarioValue)}.closed_question`;
  return {
    title: `${p}.title`,
    description: `${p}.description`,
    options: [
      { value: "positief", label: `${p}.options.positief` },
      { value: "neutraal", label: `${p}.options.neutraal` },
      { value: "negatief", label: `${p}.options.negatief` },
      { value: "noanswer", label: `${p}.options.noanswer` },
    ],
  };
}

export function openQuestionForStreet(flowKey, streetKey, scenarioValue) {
  const p = `${questionPrefix(flowKey, streetKey, scenarioValue)}.open_question`;
  return {
    title: `${p}.title`,
    description: `${p}.description`,
  };
}

export const FLOWS = {
  veltem_beisem_winksele: {
    name: "flows.veltem_beisem_winksele.name",
    order: 1,
    streets: {
      kroonstraat: {
        order: 1,
        name: "flows.veltem_beisem_winksele.streets.kroonstraat.name",
        bpartPath: "kroonstraat",
        tellit: {
          nl: "879d4f34df1e0185d2565860",
        },
      },
      centrum_veltem: {
        order: 2,
        name: "flows.veltem_beisem_winksele.streets.centrum_veltem.name",
        bpartPath: "centrum-veltem",
        tellit: {
          nl: "90b15ac3d845120409da1239",
        },
      },
      lipselaan: {
        order: 3,
        name: "flows.veltem_beisem_winksele.streets.lipselaan.name",
        bpartPath: "lipselaan",
        tellit: {
          nl: "0de7e86bf92137db57c522f3",
        },
      },
    },
  },
  herent: {
    name: "flows.herent.name",
    order: 2,
    streets: {
      wilselsesteenweg: {
        order: 1,
        name: "flows.herent.streets.wilselsesteenweg.name",
        bpartPath: "wilselsesteenweg",
        scenarios: [
          {
            value: "scenario_1",
            label:
              "flows.herent.streets.wilselsesteenweg.scenarios.scenario_1.label",
          },
          {
            value: "scenario_2",
            label:
              "flows.herent.streets.wilselsesteenweg.scenarios.scenario_2.label",
          },
        ],
        tellit: {
          nl: "a0ea655e50b5d272baba3f71",
        },
      },
      grote_molenweg: {
        order: 2,
        name: "flows.herent.streets.grote_molenweg.name",
        bpartPath: "grote-molenweg",
        tellit: {
          nl: "7bf0b1298f8c0bc95c0d9b4a",
        },
      },
      gebroeders_massantstraat: {
        order: 3,
        name: "flows.herent.streets.gebroeders_massantstraat.name",
        bpartPath: "gebroeders-massantstraat",
        tellit: {
          nl: "ebc9461edab4ff1cac5282fa",
        },
      },
      den_doren: {
        order: 4,
        name: "flows.herent.streets.den_doren.name",
        bpartPath: "den-doren",
        tellit: {
          nl: "d02e9b5e618d118248723040",
        },
      },
    },
  },
};

export const FLOW_KEYS = Object.keys(FLOWS);

export function streetsForFlow(flowKey) {
  const flow = FLOWS[flowKey];
  if (flow === undefined) return [];

  return Object.entries(flow.streets)
    .map(([key, street]) => ({ key, ...street }))
    .sort((street1, street2) => street1.order - street2.order);
}

export function streetForFlow(flowKey, streetKey) {
  return FLOWS[flowKey]?.streets[streetKey];
}

export function flowForKey(flowKey) {
  return FLOWS[flowKey];
}

export function hasClosedQuestion(flowKey, streetKey) {
  const street = streetForFlow(flowKey, streetKey);
  return street !== undefined && street.skipClosedQuestion !== true;
}

export function hasScenarioChoice(flowKey, streetKey) {
  const street = streetForFlow(flowKey, streetKey);
  return Array.isArray(street?.scenarios) && street.scenarios.length > 0;
}

export function scenarioOptionsForStreet(flowKey, streetKey) {
  const street = streetForFlow(flowKey, streetKey);
  if (!Array.isArray(street?.scenarios)) return [];

  return street.scenarios.map((scenario) => ({
    value: scenario.value,
    label: scenario.label,
  }));
}

export function lookupByBpartPath(bpartPath) {
  for (const [flowKey, flow] of Object.entries(FLOWS)) {
    for (const [streetKey, street] of Object.entries(flow.streets)) {
      if (street.bpartPath === bpartPath) return { flowKey, streetKey };
    }
  }
  return null;
}

export function tellitStoryId(flowKey, streetKey, locale) {
  const street = streetForFlow(flowKey, streetKey);
  if (street === undefined) return null;

  const localizedStory = street.tellit?.[locale];
  if (localizedStory !== undefined) return localizedStory;

  return street.tellit?.nl || null;
}
